import React, { ReactNode } from "react";
import "./BottomSheetHeader.scss";

function BottomSheetHeader({ children }: { children: ReactNode }) {
  return <div className="BottomSheetHeader">{children}</div>;
}

export default React.memo(BottomSheetHeader);
